var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8l2 2 4-4m3.667 2A6.667 6.667 0 111.333 8a6.667 6.667 0 0113.334 0z",
    stroke: "#47C28E",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuOTk5OTggOC4wMDAwNEw2Ljk5OTk4IDEwTDExIDYuMDAwMDRNMTQuNjY2NiA4LjAwMDA0QzE0LjY2NjYgMTEuNjgxOSAxMS42ODE5IDE0LjY2NjcgNy45OTk5OCAxNC42NjY3QzQuMzE4MDggMTQuNjY2NyAxLjMzMzMxIDExLjY4MTkgMS4zMzMzMSA4LjAwMDA0QzEuMzMzMzEgNC4zMTgxNCA0LjMxODA4IDEuMzMzMzcgNy45OTk5OCAxLjMzMzM3QzExLjY4MTkgMS4zMzMzNyAxNC42NjY2IDQuMzE4MTQgMTQuNjY2NiA4LjAwMDA0WiIgc3Ryb2tlPSIjNDdDMjhFIiBzdHJva2Utd2lkdGg9IjEuMzMzMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgCheckIcon as ReactComponent };